// linted by Ricky Kim

import React from 'react';
import '../App.css';
import { Link } from 'react-router-dom';
import MobileHeader from '../Components/MobileHeader';

export default class ErrorMessage extends React.Component {
    render() {
        return (
            <div>
                <MobileHeader
                    jurorName={this.props.jurorName}
                    jurorReportingDateTime={this.props.jurorReportingDateTime}
                    logOut={this.props.logOut}
                />

                <div className="Deferment">
                    Oops! Something went wrong. Please try again at another time.
                    <div>
                        <Link to="/">
                            <button className="cta_button" onClick={this.props.logOut}>
                                Close
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
